/**
 * Don't change the order. You can add to it, but don't change it.
 */
export enum AccountTypes {
  manager,
  owner,
  admin
}

export class AccountTypesArray {
  types = [
    {label: 'Manager', value: 0},
    {label: 'Owner', value: 1},
    {label: 'Admin', value: 2},
  ]
}



// WEBPACK FOOTER //
// ./src/ng2/app/models/AccountTypes.ts